import {
  getQngieAdjustmentsForQualifyingInfrastructureCompanies,
  getQngieDownwardAdjustment,
  getQngieInterestAllowance,
} from "../../../pages/group-data/utils/qngieUtil";
import {
  getPageTooltips,
  getSelectedPeriod,
} from "../../../services/GroupContext";
import {
  addGroupDataSubheaderCells,
  extractKeyValuePairsFromExcel,
  getWorksheetFromFile,
} from "./DataImportUtils";
import {
  addGroupDataWorksheet,
  downloadGroupDataImportTemplate,
  getGroupDataInitialSheetBuilder,
  validateImportedGroupData,
} from "./groupDataImportUtils";

const getTableRows = (rows, isImportTemplate = true) => {
  const qngie = getSelectedPeriod()?.qngie;
  const result = [];
  Object.entries(rows).forEach(([key, config]) => {
    addGroupDataSubheaderCells({
      list: result,
      key,
      config,
      data: qngie,
      isImportTemplate,
    });
  });
  return result;
};

const generateSheetBuilder = (isImportTemplate) => {
  const tooltips = getPageTooltips("qngieModal");
  const qngieDownwardAdjustment = getQngieDownwardAdjustment(tooltips);
  const qngieInterestAllowance = getQngieInterestAllowance(tooltips);
  const qngieAdjustmentsForQualifyingInfrastructureCompanies =
    getQngieAdjustmentsForQualifyingInfrastructureCompanies(tooltips);

  return [
    ...getGroupDataInitialSheetBuilder(),
    {
      label: `ANGIE before Interest Allowance (non-consolidated investment) and QIC elections`,
      type: "header",
      value: getSelectedPeriod()?.angie_amount_before_any_adjustments ?? 0,
      validation: "number",
    },
    { label: "" },
    { label: "Downward Adjustments", type: "header" },
    ...getTableRows(qngieDownwardAdjustment, isImportTemplate),
    {
      label: "Interest Allowance (non-consolidated investment election)",
      type: "header",
    },
    ...getTableRows(qngieInterestAllowance, isImportTemplate),
    {
      label: "Adjustments for Qualifying Infrastructure Companies",
      type: "header",
    },
    ...getTableRows(
      qngieAdjustmentsForQualifyingInfrastructureCompanies,
      isImportTemplate,
    ),
  ];
};

const worksheetName = "QNGIE";

export async function handleQngieDownloadTemplate({
  workbook,
  isImportTemplate = true,
  isClientFacing = true,
}) {
  const params = {
    sheetBuilder: generateSheetBuilder(isImportTemplate),
    documentName: "QNGIE Import Template",
    worksheetName,
    isClientFacing,
  };
  if (workbook) {
    addGroupDataWorksheet({ ...params, workbook, isImportTemplate });
  } else {
    await downloadGroupDataImportTemplate(params);
  }
}

export async function handleQngieImport({
  file,
  setErrors,
  setWarnings,
  setNewData,
}) {
  try {
    const worksheet = await getWorksheetFromFile(file, worksheetName);
    const sheetBuilder = generateSheetBuilder();
    const { results: qngie, warnings } = await extractKeyValuePairsFromExcel(
      worksheet,
      sheetBuilder,
    );

    // validate qngie keys
    validateImportedGroupData({ importedData: qngie, sheetBuilder, setErrors });

    if (warnings?.length > 0) {
      setNewData(qngie);
      setWarnings(warnings);
      return;
    }

    return qngie;
  } catch (error) {
    const errorObject = JSON.parse(error.message);
    console.error("Error importing QNGIE:", errorObject ?? error);
    if (errorObject.missingWorkSheetErrorMessage) {
      setErrors([
        {
          title:
            errorObject.missingWorkSheetErrorMessage ?? "Error Importing QNGIE",
        },
      ]);
    }
  }
}
